<template >
  <div class="">
    <vs-popup type="filled" pazaryer title="Reçete" :active.sync="popupKartDetay">
      <div>
        <div>
          <div ref="form" class="repeater-form" @submit.prevent="repeateAgain">
            <!-- Row Loop -->
            <div class="vx-row" v-for="(item, index) in items" :id="item.id" :key="index" ref="row">
              <!-- Item Name -->
              <div class="vx-col lg:w-1/5">
                <div label-for="item-name">
                  <vs-input style="width: 140px" disabled v-model="stokKodu" class="inputx" id="item-name" type="text"
                    placeholder="Stok Kodu" />
                </div>
              </div>

              <!-- Cost -->
              <div class="vx-col lg:w-1/5">
                <div label-for="cost">
                  <vs-input style="width: 140px" v-model="altStokKodu" class="inputx" id="cost" type="text"
                    placeholder="Alt Stok Kodu" />
                </div>
              </div>

              <!-- Quantity -->
              <div md="2" class="vx-col lg:w-1/5">
                <div label-for="quantity">
                  <vs-input style="width: 140px" v-model="adet" class="inputx" id="quantity" type="text"
                    placeholder="Paket içeriği (adet)" />
                </div>
              </div>
              <div md="2" class="vx-col lg:w-1/5">
                <div label-for="oran">
                  <vs-input style="width: 140px" v-model="oran" class="inputx" id="oran" type="text"
                    placeholder="Oran (yüzde)" />
                </div>
              </div>

              <!-- Remove Button -->
              <div lg="2" md="3" class="vx-col lg:w-1/5 mb-50">
                <vs-button color="success" @click="receteKaydet()" type="gradient"
                  style="border-radius: 5px">Kaydet</vs-button>
                <!--  <vs-button
                  @click="removeItem(index)"
                  color="danger"
                  type="border"
                  icon="delete"
                  >Sil</vs-button
                >-->
              </div>
            </div>
          </div>
        </div>

        <vs-divider />

        <vs-table :data="recetelist">
          <template slot="thead">
            <vs-th sort-key="ANASTOKKODU">Stok Kodu</vs-th>
            <vs-th sort-key="ALTSTOKKODU">Alt Stok Kodu</vs-th>
            <vs-th sort-key="ADET">Adet</vs-th>
            <vs-th sort-key="ORAN">Oran</vs-th>
            <vs-th>Sil</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].ANASTOKKODU }}
              </vs-td>
              <vs-td>
                {{ data[indextr].ALTSTOKKODU }}
              </vs-td>
              <vs-td>
                {{ data[indextr].ADET }}
              </vs-td>
              <vs-td>
                {{ data[indextr].ORAN }}
              </vs-td>
              <vs-td>
                <feather-icon icon="TrashIcon" class="cursor-pointer" svgClasses="w-8 h-8" style="color: red"
                  @click="receteSil(data[indextr])" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";

import state from "../../../../store/state";
import Store from "../../../../store/store";
//const { heightTransition } = mixins;
//import { heightTransition } from '@core/mixins/ui/transition'
//import Ripple from "vue-ripple-directive";
export default {
  name: "ReceteComponent",
  props: [],
  // mixins: [heightTransition],

  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],
  components: {},
  data() {
    return {
      recetelist: [],
      oran: 0,
      stokKodu: "",
      altStokKodu: "",
      adet: "",
      items: [
        {
          id: 1,
          selected: "male",
          selected1: "designer",
          prevHeight: 0,
        },
      ],
      nextTodoId: 2,
      popupKartDetay: false,
    };
  },
  methods: {
    receteKaydet() {
      //  alert(this.stokKodu);
      var vm = this;
      //virgül varsa noktaya çevir

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        oran: this.oran.replace(",", "."),
        anaStokKodu: this.stokKodu,
        altStokKodu: this.altStokKodu,
        adet: this.adet,
        token: Store.state.tokenId,
      };
      //   console.log(args);
      soap.createClient(url, function (err, client) {
        client.receteIslem(args, function (err, result) {
          if (result.receteIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.receteIslemResult);
          //   console.log("in");

          //  console.log(vm.veriler);

          if (vm.veriler.response == "Ok") {
            console.log(vm.veriler.response);
            vm.receteDetay(this.stokKodu);
          } else {
            alert("Veriler Çekilemedi");
          }
        });
      });
      vm.receteDetay(this.stokKodu);
      this.altStokKodu = "";
      this.adet = "";
      this.oran = "";
    },
    receteSil(item) {
      //    console.log("recete sil");
      console.log(item.ORAN);
      var vm = this;
      //virgül varsa noktaya çevir

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        oran: item.ORAN,
        anaStokKodu: item.ANASTOKKODU,
        altStokKodu: item.ALTSTOKKODU,
        adet: 0,
        token: Store.state.tokenId,
      };

      //   console.log(args);
      soap.createClient(url, function (err, client) {
        client.receteIslem(args, function (err, result) {
          if (result.receteIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.receteIslemResult);
          //   console.log("in");

          // console.log(vm.veriler);

          if (vm.veriler.response == "Ok") {
            //   console.log(vm.veriler.response);
            vm.receteDetay(item.ANASTOKKODU);
          } else {
            alert("Veriler Çekilemedi");
          }
        });
      });
      vm.receteDetay(item.ANASTOKKODU);
    },
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },

    receteDetay(kod) {
      this.stokKodu = kod;
      this.popupKartDetay = true;
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        anaStokKodu: kod,
        token: Store.state.tokenId,
      };
      //  console.log(args);
      soap.createClient(url, function (err, client) {
        client.receteListe(args, function (err, result) {
          if (result.receteListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.receteListeResult);
          //    console.log(vm.veriler);

          vm.recetelist = vm.veriler;
        });
      });
    },
  },

  // mounted(){this.siparisDetay()}
};
</script>
<style lang="scss">
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.con-vs-popup .vs-popup {
  width: 850px;
}

.vs-table--tbody-table {
  min-width: 0px;
}

@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }

    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>

